module.exports = __webpack_public_path__ + "static/media/aboutus-blur.d469cddf.jpg";